import axios from "axios";

import {
  reducerUsersFilters,
  reducerGetUsersList,
  reducerGetUsersClaims,
  reducerUsersClaims,
  reducerGetRoles
} from "../../reducer/accessRights/reducers/usersList";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetEmployeesList =
  (limit: any, offset: any) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      const store = getState();
      const filter = store.roles.usersList.userInputValues;
      const response = await axios.post(`${BASE_URL}/json/auth/employees/list-employees`, {
        pageNumber: 1,
        pageSize: 50,
        ...filter
      });
      dispatch(reducerGetUsersList(response.data));
    };

    export const actionGetRoles = () => async (dispatch: AppDispatch) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      try {
        const response = await axios.get(`${BASE_URL}/json/auth/roles`);
        dispatch(reducerGetRoles(response.data));
      } catch (e: any) {
        if (e.response.status === 401) {
          window.location.href = "/login";
        }
        }
    };

export const actionGetEmployeesFiltersLogin =
  () => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.get(
      `${BASE_URL}/json/auth/employees/ref-filters/logins`
    );
    dispatch(reducerUsersFilters({ ...{ logins: response.data } }));
  };

export const actionGetEmployeesFiltersRoles =
  () => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.get(
      `${BASE_URL}/json/auth/employees/ref-filters/roles`
    );

    dispatch(reducerUsersFilters({ ...{ roles: response.data } }));
  };

export const actionGetClaims =
  (id: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.get(
      `${BASE_URL}/json/auth/employees/ref-filters/claims`
    );
    dispatch(reducerGetUsersClaims({ ...response.data }));
  };

export const actionSingleEmployees =
  (id: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.get(
      `${BASE_URL}/json/auth/employees/${id}`
    );

    
    dispatch(reducerGetUsersClaims({ ...response.data }));
    return response.data;
  };

export const actionEmployeesDeleteClaims =
  (id: any, data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
console.log(id, data);
const a = {
  'employeeAuthModel': {...id, claims: data},
  'claims': data
}

const response = await axios.delete(
      `${BASE_URL}/json/auth/employees/delete-claims`,
      { data: a }
      
    );
    console.log(response);
  };

export const actionEmployeesSetClaims =
  (id: any, data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.patch(
      `${BASE_URL}/json/auth/employees/set-claims?employeeId=${id}`, data
    );

    if (response.status === 200) {
      dispatch(reducerUsersClaims(data));
    }
  };

export const actionEmployeesGetByLogin =
  (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.post(
      `${BASE_URL}/json/auth/employees/get-by-login`, data
    );
    console.log(response);
  };
